export default __webpack_public_path__ + "static/media/train.cfd6c4a2.png";